import React from 'react';
import { getFetchRequest, PREFERENCE_URL } from '../../store/requests';
import { useTranslation } from 'react-i18next';
import {errorCallback, makeUrl} from "../../util";
import { Button } from '@chapche/ui';

const DownloadCSVFileButton = () => {
    const { i18n } = useTranslation();
    const downloadCSVFile = () => {
        getFetchRequest(makeUrl([PREFERENCE_URL, i18n.resolvedLanguage, '/csv/']), async (response) => {
            const blob = await response.blob();
            const newBlob = new Blob([blob]);
            const url = window.URL.createObjectURL(newBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `${i18n.resolvedLanguage}.csv`,
            );
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }, errorCallback, true);
    };

    return (
        <Button variant="outline" className="preference__download" onClick={downloadCSVFile}>
            {i18n.t('app.page.preference.downloadCSV')}
        </Button>
    );
};

export default DownloadCSVFileButton;
